import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { DELETE_INBOX_MESSAGE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import { INBOX_MESSAGES_UNREAD_COUNT_TAGS } from './getInboxMessageUnreadCount';
import type { DeleteInboxMessagePayload } from '../types/deleteInboxMessage.types';

export const deleteInboxMessage = (builder: BuilderType) =>
  builder.mutation<void, DeleteInboxMessagePayload>({
    invalidatesTags: [INBOX_MESSAGES_UNREAD_COUNT_TAGS],
    query: (params) => ({
      data: params,
      isErrMsgConcatErrCode: false,
      method: 'POST',
      url: DELETE_INBOX_MESSAGE_URL,
    }),
    transformResponse: (response: GenericApiResponse<void>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
